import Alpine from 'alpinejs'
import globalStore from '@/js/store'
import components from '@/js/alpine'

import '@/styles/main.scss'

if (!window.acf) {
  window.Alpine = Alpine

  Alpine.store('global', globalStore())

  const registerComponent = async (component) => {
    let componentSlug = component.replace(/-./g, (x) => x[1].toUpperCase())

    if (document.querySelectorAll(`[x-data^=${componentSlug}]`).length > 0) {
      new URL(`./alpine/${component}.js`, import.meta.url)

      await import(`./alpine/${component}.js`)
        .then((module) => {
          Alpine.data(componentSlug, module.default)
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }

  const registerComponents = async () => {
    for (const component of components) {
      await registerComponent(component)
    }
    Alpine.start()
  }

    ; (async () => {
      await registerComponents()
    })()
}

// load defered videos
window.videosReady = false

document.onreadystatechange = function (event) {
  if (document.readyState === 'complete') {
    const videos = document.querySelectorAll('[data-src-defer]')
    const videos_array = [...videos]
    videos_array.forEach((video) => {
      video.setAttribute('src', video.getAttribute('data-src-defer'))
    })
    window.videosReady = true
  }
}

// Google CSE doesn't provide alt text for thumbnails, which is an accessibility issue,
// so we have to add it ourselves after the results load. This function finds all the
// result blocks, gets the image and title for each one, and sets the alt text of the
// image to the title of the result.
function updateCseThumbnailAlts() {
  // Find all result blocks
  document.querySelectorAll('.gsc-webResult').forEach(result => {
    // Find the image and the title link in this result
    const img = result.querySelector('img.gs-image');
    const titleLink = result.querySelector('.gs-title a.gs-title');
    if (img && titleLink) {
      // Set alt to the title text
      img.alt = 'Thumbnail for: ' + titleLink.textContent.trim();
    }
  });
}

// Google CSE loads results dynamically, so listen for DOM changes
const cseResults = document.querySelector('.search__results');
if (cseResults) {
  const observer = new MutationObserver(() => {
    updateCseThumbnailAlts();
  });
  observer.observe(cseResults, { childList: true, subtree: true });
  // Also run once on page load
  updateCseThumbnailAlts();
}

// Alert bar functionality
const formData = new FormData();

formData.append('action', 'get_alert_bar');
formData.append('post_id', wp_config.post_id);

// fetch alert bar
fetch(wp_config.ajaxurl, {
  method: 'POST',
  body: formData,
  cache: 'no-cache',
  headers: {
    page_cache_maximum_age: 0,
  },
})
  .then((response) => response.json())
  .then((data) => {
    if (data.enabled) {
      document.getElementById('alertBar').classList.add('is-active')
      document.getElementById('alertBar').innerHTML = `
        <section class="alert-bar alert-bar--${data.background_color}">
            <div class="alert-bar__inner">
                <div class="alert-bar__text">${data.message}</div>
            </div>
        </section>
    `
    }
  })

class FormAssemblyForms {
  constructor() {
    this.forms = document.querySelectorAll('form[action*="lvc.tfaforms.net"]');

    if (this.forms.length > 0) {
      this.listen();
      this.fixRadioAccessibility();
    }
  }

  listen() {
    this.forms.forEach((form) => {
      form.addEventListener('form.validation.formassembly', (e) => {
        if ("passed" === e.detail.statusText) {
          const data = this.getFormData(form);

          dataLayer.push(data);
        }
      })
    });
  }

  getFormData(form) {
    let data = {
      event: "formassembly_submit",
      form_id: form.id
    };

    const degreeField = this.getFieldByLabel(form, "Degree");
    let degreeFieldId = null;
    if (degreeField) {
      data.degree = degreeField.selectedIndex ? degreeField.options[degreeField.selectedIndex]?.text : degreeField.value;
      degreeFieldId = degreeField.selectedIndex ? degreeField.options[degreeField.selectedIndex]?.id : degreeField.id;
    }

    // this is needed because the form has multiple fields that conditionally appear based on the degree selected, and the program of interest field is one of those, so we have to look for the one that is currently selected in the form, which is indicated by the data-selected attribute
    const programField = document.querySelector('form[id="' + form.id + '"] fieldset[data-condition="`#' + degreeFieldId + '`"] input[data-selected]');

    if (programField) {
      data.program_of_interest = programField.value;
    }

    const fieldOfInterest = this.getFieldByLabel(form, "Field of Interest");
    if (fieldOfInterest) {
      data.field_of_interest = fieldOfInterest.selectedIndex ? fieldOfInterest.options[fieldOfInterest.selectedIndex]?.text : fieldOfInterest.value;
    }

    return data;

  }

  getFieldByLabel(form, labelText) {
    const labels = document.querySelectorAll(`form[id="${form.id}"] label`); // this is a shim because the forms are iframed in and we can't reliably query within the form itself, so we have to query the whole document and then filter by form ID

    for (const label of labels) {
      if (label.textContent.trim() === labelText) {
        const fieldId = label.getAttribute('for');
        if (fieldId) {
          return form.querySelector(`#${fieldId}`);
        }
      }
    }

    return null;
  }

  fixRadioAccessibility() {
    const groups = document.querySelectorAll('.oneField[role="radiogroup"]');

    groups.forEach(group => {

      const label = group.querySelector('.preField');
      const wrapper = group.querySelector('.inputWrapper');

      if (!label || !wrapper) return;

      // Preserve the label ID
      const labelId = label.id;
      const questionText = label.textContent.trim();
      const ariaLabelledby = group.getAttribute('aria-labelledby');

      // Create fieldset
      const fieldset = document.createElement('fieldset');
      fieldset.classList.add('fa-radio-fieldset');

      // Move ARIA attributes to fieldset
      if (ariaLabelledby) {
        fieldset.setAttribute('aria-labelledby', ariaLabelledby);
      }
      // Optionally, move role too (not required for fieldset, but for ARIA parity)
      fieldset.setAttribute('role', 'radiogroup');

      // Create legend and move the ID to it
      const legend = document.createElement('legend');
      legend.textContent = questionText;

      if (labelId) {
        legend.id = labelId;
      }

      fieldset.appendChild(legend);

      // Move wrapper inside fieldset
      fieldset.appendChild(wrapper);

      // Replace label with fieldset
      label.remove();
      group.appendChild(fieldset);

      // Remove role/aria from group to avoid duplicate roles
      group.removeAttribute('role');
      group.removeAttribute('aria-labelledby');

      // Ensure each radio has proper role
      fieldset.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.setAttribute('role', 'radio');
      });

    });
  }
}

const formAssemblyForms = new FormAssemblyForms();

class WpFormsForms {
  constructor() {
    this.forms = document.querySelectorAll('.wpforms-form');

    if (this.forms.length > 0) {
      this.fixRadioAccessibility();
    }
  }

  fixRadioAccessibility() {
    // Find all WPForms radio fields
    document.querySelectorAll('.wpforms-field-radio').forEach(field => {
      // Skip if already fixed
      if (field.querySelector('fieldset')) return;

      // Get the main label and the list of radio options
      const label = field.querySelector('.wpforms-field-label');
      const ul = field.querySelector('ul');

      if (!label || !ul) return;

      // Create fieldset and legend
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'wpforms-radio-fieldset';
      const legend = document.createElement('legend');
      legend.textContent = label.textContent.trim();
      fieldset.appendChild(legend);

      // Move the radio list into the fieldset
      fieldset.appendChild(ul);

      // Replace label and ul with fieldset
      label.remove();
      field.appendChild(fieldset);
    });
  }
}

const wpForms = new WpFormsForms();

// Autofill master degree field in FormAssembly
// Check if particular form is on page
if (document.getElementById('217885')) {
  const params = new URLSearchParams(window.location.search);
  const degree = params.get('degree');
  const poi = params.get('poi');

  // Only proceed if both degree and poi are present
  if (degree && poi) {
    // Helper to wait for the field to appear
    function waitForField(selector, timeout = 5000) {
      return new Promise((resolve, reject) => {
        const interval = 100;
        let elapsed = 0;
        const check = () => {
          const el = document.querySelector(selector);
          if (el) return resolve(el);
          elapsed += interval;
          if (elapsed >= timeout) return reject();
          setTimeout(check, interval);
        };
        check();
      });
    }

    // Set the degree field
    waitForField('#tfa_597, [title="Degree"]').then((degreeField) => {
      if (degree.toLowerCase() === 'master') {
        const masterOption = Array.from(degreeField.options).find(
          (option) => option.text.trim().toLowerCase() === 'master'
        );
        if (masterOption) {
          degreeField.value = masterOption.value;
        }
      }
    }).catch(() => {
      console.warn('Degree field not found');
    });

    // Find and set Program of Interest field
    waitForField('#tfa_626, [title="Academic Program of Interest"]').then((field) => {
      field.value = poi;
      field.focus();
    }).catch(() => {
      console.warn('Academic Program of Interest field not found');
    });
  }
}

// ChatbotWidget class for embedding a chatbot widget on the site
// Handles rendering, toggling, and communication with the embedded iframe
class ChatbotWidget {
  /**
   * Constructor for ChatbotWidget
   * @param {Object} options - Configuration options
   * @param {string} options.embedUrl - URL for the chatbot iframe
   * @param {string} options.iconUrl - URL for the chatbot icon
   */
  constructor(options = {
    embedUrl: '',
    iconUrl: ''
  }) {
    this.options = options;
    this.active = false;
    this.element = null;
    this.embed = null;

    this.render();
    this.listen();
  }

  /**
   * Renders the chatbot widget in the DOM
   */
  render() {
    const chatbotWidgetContainer = document.createElement('div');
    chatbotWidgetContainer.id = 'chatbot-widget';

    const chatbotWidgetHeader = document.createElement('button');
    chatbotWidgetHeader.className = 'chatbot-widget__header';
    chatbotWidgetHeader.setAttribute('aria-expanded', 'false');
    chatbotWidgetHeader.setAttribute('aria-controls', 'chatbotWidgetIframe');

    const headerLogo = document.createElement('div');
    headerLogo.className = 'chatbot-widget__header-logo';
    headerLogo.innerHTML = '<img src="' + this.options.iconUrl + '" alt="Chat icon">';

    const headerTitle = document.createElement('div');
    headerTitle.className = 'chatbot-widget__header-title';
    headerTitle.textContent = 'Let’s Chat';

    const headerToggle = document.createElement('div');
    headerToggle.className = 'chatbot-widget__header-toggle';
    headerToggle.innerHTML = '<span class="line"></span><span class="line"></span>';

    const chatbotWidgetBody = document.createElement('div');
    chatbotWidgetBody.className = 'chatbot-widget__body';
    chatbotWidgetBody.innerHTML = '<iframe id="chatbotWidgetIframe" title="LVC Chatbot Widget" class="chatbot-widget__iframe" allow="local-network-access *" src="' + this.options.embedUrl + '" frameborder="0"></iframe>';

    chatbotWidgetHeader.appendChild(headerLogo);
    chatbotWidgetHeader.appendChild(headerTitle);
    chatbotWidgetHeader.appendChild(headerToggle);

    chatbotWidgetContainer.appendChild(chatbotWidgetHeader);
    chatbotWidgetContainer.appendChild(chatbotWidgetBody);

    document.body.appendChild(chatbotWidgetContainer);

    this.element = chatbotWidgetContainer;
    this.embed = chatbotWidgetBody.querySelector('iframe');
  }

    /**
     * Sets up event listeners for the chatbot widget
     */
    listen() {
        this.element.addEventListener('click', () => {
            this.toggle();
        });

        // Allow toggling the chatbot with Enter or Space keys for accessibility
        this.element.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.toggle();
            }
        });

    if (this.embed) {
      window.addEventListener('message', this.handleMessage.bind(this));

      this.embed.addEventListener('load', this.handleLoad.bind(this));
      this.embed.addEventListener('error', this.handleError.bind(this));
    }
  }

  /**
   * Toggles the chatbot open/closed state
   */
  toggle() {
    if (this.active) {
      this.deactivate();
    } else {
      this.activate();
    }
  }

  /**
   * Activates (opens) the chatbot widget
   */
  activate() {
    this.active = true;

    document.documentElement.classList.add('chatbot-active');

    this.element.classList.add('is-active');
    this.element.classList.add('is-open');
    this.element.querySelector('.chatbot-widget__header').setAttribute('aria-expanded', 'true');
  }

  /**
   * Deactivates (closes) the chatbot widget
   */
  deactivate() {
    this.active = false;

    document.documentElement.classList.remove('chatbot-active');

    this.element.classList.remove('is-active');
    this.element.classList.remove('is-open');
    this.element.querySelector('.chatbot-widget__header').setAttribute('aria-expanded', 'false');
  }

  /**
   * Handles messages received from the chatbot iframe
   * @param {MessageEvent} event
   */
  handleMessage(event) {
    if (event.origin !== new URL(this.options.embedUrl).origin) {
      return;
    }

    const data = event.data;

    console.log('Received message from chatbot iframe:', data);
  }

  /**
   * Handles iframe load event
   */
  handleLoad() {
    this.element.classList.add('is-loaded');
  }

  /**
   * Handles iframe error event
   */
  handleError() {
    console.error('Error loading chatbot iframe.');
    this.element.classList.add('is-error');
  }
}

function initChatbotWidget() {
  if (
    document.body.classList.contains('home') &&
    window.chatbotWidget === undefined
  ) {
    window.chatbotWidget = new ChatbotWidget({
      embedUrl: 'https://lvcwebapps.lvc.edu/lvc/',
      iconUrl: '/wp-content/uploads/2026/01/chatbot-logo.svg'
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initChatbotWidget);
} else {
  initChatbotWidget();
}